import { measureTables, getCorrectTable, clearTables } from './measure-tables'
import type { TableData } from './types'

let currentTable: TableData | null = null
let hideSamepageHeader: boolean
const eventListenerRemovers: Array<() => void> = []

const getHeightOffset = (): number => {
  const computedStyle = getComputedStyle(document.documentElement)

  return (
    [
      '--sticky-header-height',
      '--secondary-subheader-height',
      '--system-banner-height',
    ].reduce((acc, key) => {
      const height = computedStyle.getPropertyValue(key)

      if (!height) {
        return acc
      }

      return acc + parseInt(height.replace('px', ''), 10)
    }, 0) + 60
  )
}

const moveHeader = (tableObject: TableData | null): void => {
  if (!tableObject) {
    return
  }
  const header = tableObject.header
  const translate = `translate(0, ${window.scrollY - tableObject.top}px)`
  header.style.transform = translate
}

const setStyle = (tableObject: TableData | null): void => {
  if (!tableObject) {
    return
  }
  tableObject.header.style.position = 'relative'
  tableObject.header.style.backgroundColor = 'white'
  tableObject.header.style.zIndex = tableObject.table.style.zIndex + '2'
  tableObject.table.style.borderCollapse = 'separate'
  tableObject.table.style.borderSpacing = '0px'
}

const removeStyle = (tableObject: TableData | null): void => {
  if (!tableObject) {
    return
  }
  tableObject.header.style.backgroundColor = 'white'
  tableObject.header.style.transform = ''
  tableObject.table.style.borderCollapse = 'collapse'
  tableObject.table.style.borderSpacing = '0px'
}

const scrollHandler = (): void => {
  const newTable = getCorrectTable(window.scrollY, hideSamepageHeader)
  if (currentTable !== newTable) {
    removeStyle(currentTable)
    setStyle(newTable)
  }
  if (newTable) {
    moveHeader(newTable)
  }
  currentTable = newTable
}

window.onDomLoad(() => {
  hideSamepageHeader = !!document.querySelector('.usr-hide-samepage-header')
  if (hideSamepageHeader) {
    //GIVEN we have `.usr-hide-samepage-header` on the page.
    //THEN all headers should have it except 1
    const elements = document.querySelectorAll(
      '.usr-repeated-header:not(.usr-hide-samepage-header)'
    )
    if (elements.length !== 1) {
      return
    }
  }

  teardown()

  const heightOffset = getHeightOffset()

  window.requestAnimationFrame(() => {
    measureTables(heightOffset)
  })

  window.addEventListener('scroll', scrollHandler, { passive: true })

  eventListenerRemovers.push(() => {
    window.removeEventListener('scroll', scrollHandler)
  })
})

const teardown = (): void => {
  eventListenerRemovers.forEach((remover: () => void) => remover())
  clearTables()
}
